<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="base.name" v-validate="'required'">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="email" name="email" id="email" placeholder="Email" v-model="base.email" v-validate="'required|email'">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </p>
        <p class="control">
          <label class="label">Social Reason</label>
          <input :class="{'input': true, 'is-danger': errors.has('social_reason'), 'is-disabled': inProgress}" type="text" name="social_reason" id="social_reason" placeholder="Social Reason" v-model="base.social_reason" v-validate="'required'">
          <span v-show="errors.has('social_reason')" class="help is-danger">{{ errors.first('social_reason') }}</span>
        </p>
        <p class="control">
          <label class="label">CNPJ</label>
          <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model="base.cnpj" v-validate="'required|numeric'">
          <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
        </p>
        <p class="control">
          <label class="label">Municipal Inscription</label>
          <input :class="{'input': true, 'is-danger': errors.has('municipal_inscription'), 'is-disabled': inProgress}" type="text" name="municipal_inscription" id="municipal_inscription" placeholder="Municipal Inscription" v-model="base.municipal_inscription" v-validate="'numeric'">
          <span v-show="errors.has('municipal_inscription')" class="help is-danger">{{ errors.first('municipal_inscription') }}</span>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="base.nf">
            NFS-e
          </label>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Phone</label>
              <input :class="{'input': true, 'is-danger': errors.has('phone'), 'is-disabled': inProgress}" type="text" name="phone" id="phone" placeholder="Phone" v-model="base.phone" v-validate="'required'">
              <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Emergency Phone</label>
              <input :class="{'input': true, 'is-danger': errors.has('emergency_phone'), 'is-disabled': inProgress}" type="text" name="emergency_phone" id="emergency_phone" placeholder="Emergency Phone" v-model="base.emergency_phone">
              <span v-show="errors.has('emergency_phone')" class="help is-danger">{{ errors.first('emergency_phone') }}</span>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">CEP</label>
          <input :class="{'input': true, 'is-danger': errors.has('cep'), 'is-disabled': inProgress}" type="cep" name="cep" id="cep" placeholder="CEP" v-model="base.cep" @change="cep" v-validate="'required|numeric'">
          <span v-show="errors.has('cep')" class="help is-danger">{{ errors.first('cep') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Address</label>
              <input :class="{'input': true, 'is-danger': errors.has('address'), 'is-disabled': inProgress || cepProgress}" type="text" name="address" id="address" placeholder="Address" v-model="base.address" v-validate="'required'">
              <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Address Number</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_number'), 'is-disabled': inProgress || cepProgress}" type="text" name="address_number" id="address_number" placeholder="Address Number" v-model="base.address_number" v-validate="'required|numeric'">
              <span v-show="errors.has('address_number')" class="help is-danger">{{ errors.first('address_number') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Neighborhood</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_neighborhood'), 'is-disabled': inProgress || cepProgress}" type="text" name="address_neighborhood" id="address_neighborhood" placeholder="Neighborhood" v-model="base.address_neighborhood" v-validate="'required'">
              <span v-show="errors.has('address_neighborhood')" class="help is-danger">{{ errors.first('address_neighborhood') }}</span>
            </p>
          </div>
        </div>
        <p class="control is-expanded">
          <label class="label">Address Complement</label>
          <input :class="{'input': true, 'is-danger': errors.has('address_complement'), 'is-disabled': inProgress}" type="text" name="address_complement" id="address_complement" placeholder="Address Complement" v-model="base.address_complement">
          <span v-show="errors.has('address_complement')" class="help is-danger">{{ errors.first('address_complement') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">City</label>
              <input :class="{'input': true, 'is-danger': errors.has('city'), 'is-disabled': inProgress || cepProgress}" type="text" name="city" id="city" placeholder="City" v-model="base.city" v-validate="'required'">
              <span v-show="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">IBGE</label>
              <input :class="{'input': true, 'is-danger': errors.has('cmun'), 'is-disabled': inProgress || cepProgress}" type="text" name="cmun" id="cmun" placeholder="" v-model="base.cmun" v-validate="base.nf ? 'required' : ''">
              <span v-show="errors.has('cmun')" class="help is-danger">{{ errors.first('cmun') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">State</label>
              <input :class="{'input': true, 'is-danger': errors.has('state'), 'is-disabled': inProgress || cepProgress}" type="text" name="state" id="state" placeholder="State" v-model="base.state" v-validate="'required'">
              <span v-show="errors.has('state')" class="help is-danger">{{ errors.first('state') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Country</label>
              <input :class="{'input': true, 'is-danger': errors.has('country'), 'is-disabled': inProgress || cepProgress}" type="text" name="country" id="country" placeholder="Country" v-model="base.country" v-validate="'required'">
              <span v-show="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</span>
            </p>
          </div>
        </div>
        <p :class="{'control': true}">
          <label class="label">E-mails Invoice
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_invoice')}" name="emails_invoice" id="emails_invoice" placeholder="E-mails" v-model="base.emails_invoice"></textarea>
          <span v-show="errors.has('emails_invoice')" class="help is-danger">{{ errors.first('emails_invoice') }}</span>
        </p>
        <p :class="{'control': true}">
          <label class="label">E-mails Reconfirmation
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_reconfirmation')}" name="emails_reconfirmation" id="emails_reconfirmation" placeholder="E-mails" v-model="base.emails_reconfirmation"></textarea>
          <span v-show="errors.has('emails_reconfirmation')" class="help is-danger">{{ errors.first('emails_reconfirmation') }}</span>
        </p>
        <p :class="{'control': true}">
          <label class="label">E-mails Notification
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_notification')}" name="emails_notification" id="emails_notification" placeholder="E-mails" v-model="base.emails_notification"></textarea>
          <span v-show="errors.has('emails_notification')" class="help is-danger">{{ errors.first('emails_notification') }}</span>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="base.operator">
            Operator
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="base.invoicable">
            Invoicable
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="base.is_markup">
            Markup
          </label>
        </p>
        <p class="control is-expanded">
          <label class="label">Markup</label>
          <input :class="{'input': true, 'is-danger': errors.has('net_price')}" name="markup" id="markup" @focusout="backi('markup')" @focusin="cleani('markup')" type="text" placeholder="" v-model="base.markup" v-validate="'required|decimal'">
          <span v-show="errors.has('markup')" class="help is-danger">{{ errors.first('markup') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Booking Fee</label>
          <input :class="{'input': true, 'is-danger': errors.has('bf')}" type="text" placeholder="" name="bf" id="bf" @focusout="backi('bf')" @focusin="cleani('bf')" v-model="base.bf" v-validate="'required|decimal'">
          <span v-show="errors.has('bf')" class="help is-danger">{{ errors.first('bf') }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress }" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || cepLoading, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      base_id: {
        type: Number
      }
    },
    data () {
      return {
        base: {
          name: '',
          cnpj: '',
          social_reason: '',
          municipal_inscription: '',
          nf: 0,
          cep: '',
          city: '',
          cmin: '',
          state: '',
          country: '',
          address: '',
          address_number: '',
          address_complement: '',
          address_neighborhood: '',
          phone: '',
          emergency_phone: '',
          operator: false,
          invoicable: false,
          is_markup: false,
          markup: '',
          prev_markup: '',
          bf: '',
          prev_bf: '',
          emails_invoice: '',
          email: ''
        },
        cepProgress: true,
        cepLoading: false,
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      cep () {
        this.cepProgress = true
        this.cepLoading = true
        this.context.$http.get(this.context.$store.state.config.apiURL + '/cep/' + this.base.cep).then((response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          this.base.address = response.body.logradouro
          this.base.city = response.body.localidade
          this.base.state = response.body.uf
          this.base.country = 'Brasil'
          this.base.address_neighborhood = response.body.bairro
          this.base.cmun = response.body.ibge
        }, (response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          this.error = response.body.message
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      cleani (data) {
        if (data === 'bf') {
          this.base.prev_bf = this.base.bf
          this.base.bf = ''
        } else {
          this.base.prev_markup = this.base.markup
          this.base.markup = ''
        }
      },
      backi (data) {
        if (data === 'bf') {
          if (this.base.bf === '') {
            this.base.bf = this.base.prev_bf
          }
        } else {
          if (this.base.markup === '') {
            this.base.markup = this.base.prev_markup
          }
        }
      },
      save () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.inProgress = true
            this.error = ''
            let url = this.context.$store.state.config.apiURL + '/bases/' + this.base.id
            this.context.$http.post(url, this.base).then((response) => {
              this.inProgress = false
              this.close(false, {ok: true, message: 'The base ' + response.body.name + ' was successfully save'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/bases/' + this.base_id).then((response) => {
          this.base = response.body
          this.base.operator = parseInt(response.body.operator) === 1
          this.base.invoicable = parseInt(response.body.invoicable) === 1
          this.base.is_markup = parseInt(response.body.is_markup) === 1
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Base.vue?f7a71dd0